import { QueryHookOptions } from '@apollo/client/react/types/types';

import {
  Cpg,
  GetScanDataSftpCredentialsWithStoreDetailsListQuery,
  GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables,
} from '@occc/graphql';

import { SubmissionGroupSiteStatus } from './scan-data-submission-groups.types';

export const submissionGroupSiteStatusToColorMap: Record<
  SubmissionGroupSiteStatus,
  'success' | 'warning' | 'default'
> = {
  ACTIVE: 'success',
  TESTING: 'warning',
  NOT_SUBMITTING: 'default',
};

export const submissionGroupSiteStatusToLabelMap: Record<SubmissionGroupSiteStatus, string> = {
  ACTIVE: 'Active',
  TESTING: 'Testing',
  NOT_SUBMITTING: 'Not Submitting',
};

export const ALTRIA_AFTER_PARAM = 'altria-after';
export const ALTRIA_BEFORE_PARAM = 'altria-before';
export const MSA_AFTER_PARAM = 'msa-after';
export const MSA_BEFORE_PARAM = 'msa-before';
export const RJR_AFTER_PARAM = 'rjr-after';
export const RJR_BEFORE_PARAM = 'rjr-before';
export const DEFAULT_PAGE_INFO_PATH = 'listScanDataSftpCredentialsWithStoreDetails.pageInfo';

export const DEFAULT_ALTRIA_QUERY_VARIABLES: QueryHookOptions<
  GetScanDataSftpCredentialsWithStoreDetailsListQuery,
  GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables
> = {
  fetchPolicy: 'cache-and-network',
  notifyOnNetworkStatusChange: true,
  variables: { cpg: Cpg.Altria },
};

export const DEFAULT_MSA_QUERY_VARIABLES: QueryHookOptions<
  GetScanDataSftpCredentialsWithStoreDetailsListQuery,
  GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables
> = {
  fetchPolicy: 'cache-and-network',
  notifyOnNetworkStatusChange: true,
  variables: { cpg: Cpg.Msa },
};

export const DEFAULT_CIRCANA_QUERY_VARIABLES: QueryHookOptions<
  GetScanDataSftpCredentialsWithStoreDetailsListQuery,
  GetScanDataSftpCredentialsWithStoreDetailsListQueryVariables
> = {
  fetchPolicy: 'cache-and-network',
  notifyOnNetworkStatusChange: true,
  variables: { cpg: Cpg.Circana },
};
